
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hiring-a-bagpiper",
      function () {
        return require("private-next-pages/hiring-a-bagpiper.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hiring-a-bagpiper"])
      });
    }
  